import React from 'react';
import { Checkbox, TextField } from '@material-ui/core';
import { Autocomplete as AutocompleteMui } from '@material-ui/lab';
import { IAutocompleteMultiple, IOptionsMultiple } from './interfaces';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import CheckBoxIcon from '@material-ui/icons/CheckBox';
import { Controller } from 'react-hook-form';

export type { IOptionsMultiple } from './interfaces';

export const AutocompleteMultiple = (props: IAutocompleteMultiple) => {
  const {
    objects: objectsProps,
    objectKey,
    objectValue,
    label,
    loading,
    defaultValue,
    showObjectKey,
    variant,
    control,
    name
  } = props;
  const options: IOptionsMultiple[] = [];
  const objects = objectsProps || [];

  objects.forEach((object) => {
    if (objectKey && objectValue) {
      options.push({ key: object[objectKey], value: object[objectValue] });
    }
  });

  const index = objects.findIndex((object) => {
    return object[objectKey] === defaultValue;
  });

  return (
    <Controller
      control={control}
      name={name}
      defaultValue={options[index]}
      render={({ field: { onChange }, fieldState: { error } }) => (
        <AutocompleteMui
          loading={loading}
          options={options}
          getOptionLabel={(option: IOptionsMultiple): string =>
            showObjectKey ? `${option.key} - ${option.value}` : option.value
          }
          getOptionSelected={(option, value) => option.value === value.value}
          onChange={(_, obj) => onChange(obj)}
          loadingText="Carregando..."
          noOptionsText="Sem opções"
          disableCloseOnSelect
          multiple
          renderInput={(params) => (
            <TextField
              {...params}
              variant={variant || 'standard'}
              label={label}
              fullWidth
              error={!!error}
              helperText={error?.message || null}
            />
          )}
          renderOption={(option, { selected }) => (
            <>
              <Checkbox
                icon={<CheckBoxOutlineBlankIcon />}
                checkedIcon={<CheckBoxIcon />}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option.value}
            </>
          )}
        />
      )}
    />
  );
};
